import { render } from "./WelcomeDialog.vue?vue&type=template&id=75fec6a0&scoped=true"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"

import "./WelcomeDialog.vue?vue&type=style&index=0&id=75fec6a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fec6a0"]])

export default __exports__